export interface IOpenUpload {
  open: boolean;
  isAns: boolean;
}

export type State = IOpenUpload;

export type IOpenUploadStateAction = State & Action;

export type Action = {
  openUpload: (isAns?: boolean) => void;
  closeUpload: () => void;
};

export const initialState: State = {
  open: false,
  isAns: false,
};
